"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ofActionType = ofActionType;
const rxjs_1 = require("rxjs");
function ofActionType(...creators) {
    return (0, rxjs_1.filter)((action) => creators.some((creator) => "match" in creator && creator.match(action)));
}
//# sourceMappingURL=ofActionType.js.map